import { useAppStore } from "@/global/store";
import { selectUser } from "@/global/store/data/user";
import {
  Box,
  Divider,
  Link,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from "@mui/material";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { TbShirtSport } from "react-icons/tb";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";

export const purchaseGiftCardLanguages = {
  pageTitle: "Give the gift of Diamondbacks Baseball",
  mainCardTitle: "Share a Gift",
  mainCardDescription:
    "Share the magic of Diamondbacks baseball with a friend or loved one. Upon purchase of the gift, a unique code will be generated for the intended recipient to redeem. Once redeemed, the gift is non-refundable.",
  amountTitle: "Gift Amount",
  recipientTitle: "Recipient",
  recipientEnabledDesc:
    "The Recipient will be sent an email with the unique code for them to redeem their gift. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all Arizona Diamondbacks games at Chase Field.",
  recipientDisabledDesc:
    "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift, they will be prompted to enter their unique code to redeem the gift. Once redeemed, the recipient will receive an account credit that they use to purchase tickets for all Arizona Diamondbacks games at Chase Field.",
};

export const redeemGiftCardLanguages = {
  pageTitle: "Give the gift of Diamondbacks Baseball",
  mainCardTitle: "Redeem Gift",
  mainCardLoggedInDesc:
    "Please input the case sensitive code provided to redeem the value of the gift card to the Hippodrome Broadway Series in Baltimore account above.",
  mainCardLoggedOutDesc:
    "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster.",
  successDesc: "has been added to to your account!",
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Click Get Started",
    description:
      "Click Get Started on your desktop, laptop, or mobile device to begin.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Connect your Pistons account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Games",
    description: "Select your games and seats.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Account Manager within 24 hours of redemption. Reach out to Live Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title: "How does the Pistons Flex program work?",
    description:
      "The Pistons Flex program allows fans to select any seat to any game. Simply log into your Pistons Account manager and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description:
      "No. You have the opportunity to select all the games you’d like to attend throughout the season. This is subject to change.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description:
      "Event tickets are delivered directly within your Pistons Account Manager within an hour of selection.",
  },
];

export function CheckoutTerms() {
  return (
    <>
      By purchasing you agree to receive SMS alerts regarding ticket delivery
      and agree to the{" "}
      <Link
        sx={{
          fontWeight: 500,
          color: "primary.main",
          textDecoration: "none",
        }}
        href="https://www.mlb.com/app/ballpark/official-information/privacy-policy"
      >
        MLB Privacy Policy
      </Link>{" "}
      and{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}

export function RegistrationTerms() {
  return (
    <>
      By creating an account you agree to receive email notifications regarding
      your purchase and to the{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"

        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>
      ,{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>{" "}
      and Broadway Across America’s{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"
        href={
          "https://www.broadwayacrossamerica.com/terms-conditions/#gift-cards"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions.
      </Link>
    </>
  );
}
